export default __webpack_public_path__ + "static/media/ManejoDeFlotas_Icon.a0bb7de8.svg";